namespace Nobox {
    export interface contactGroup {
        In?: string;
        Count?: number;
    }
}
